import React, { memo } from "react";
import { Button } from "@/components/ui/button";
import BrandedLoader from "@/components/ui/BrandedLoader";
import { CreditBalanceDisplay } from "@/components/credits/CreditBalanceDisplay";
import { AccountDropdown } from "./AccountDropdown";

interface AuthButtonsProps {
  isSigningOut: boolean;
  showProtectedLinks: boolean;
  handleLogout: (e: React.MouseEvent) => void;
  handleNavigate: (path: string) => (e: React.MouseEvent) => void;
}

const AuthButtonsComponent = ({
  isSigningOut,
  showProtectedLinks,
  handleLogout,
  handleNavigate
}: AuthButtonsProps) => {
  if (isSigningOut) {
    return (
      <div className="flex items-center justify-end w-full">
        <div className="w-6 h-6">
          <BrandedLoader />
        </div>
      </div>
    );
  }

  if (showProtectedLinks) {
    return (
      <div className="flex items-center justify-end gap-3 min-w-[160px]">
        {/* Credit balance badge — clicking navigates to Account › Credits */}
        <div className="hidden lg:flex items-center">
          <CreditBalanceDisplay variant="compact" showBuyButton={true} />
        </div>
        {/* Avatar dropdown — My Knits, My Stash, Account, Sign out */}
        <AccountDropdown handleLogout={handleLogout} />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 min-w-[200px]">
      <Button
        variant="ghost"
        className="bg-transparent text-yarn-slate border border-yarn-slate/20 hover:bg-white/40 hover:text-primary w-20"
        onClick={handleNavigate("/login")}
      >
        Sign in
      </Button>
      <Button
        className="bg-primary text-white hover:bg-primary/90 hover:text-white shadow-sm w-32"
        onClick={handleNavigate("/register")}
      >
        Create Account
      </Button>
    </div>
  );
};

AuthButtonsComponent.displayName = 'AuthButtons';

export const AuthButtons = memo(AuthButtonsComponent);
